import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import { sendFormEmail } from './utils/email'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)

// Dev helper: expose a console test function
;
(window as any).sendEmailTest = () =>
  sendFormEmail({
    source: 'Console Test',
    parentName: 'Test Parent',
    email: 'test@example.com',
    phone: '555-555-5555',
    selectedProgram: 'Console',
    childName: 'Student',
    childAge: '10',
    message: 'Hello from console',
  })
    .then(() => console.log('EmailJS OK'))
    .catch((e) => console.error('EmailJS ERR', e))
